import { useState } from 'react';
import Link from 'next/link';
import { useUnit } from 'effector-react';
import {
  RiArrowRightLine,
  RiBarChartHorizontalLine,
  RiCloseLine,
  RiGridFill,
  RiHeartLine,
  RiMenuLine,
  RiPhoneLine,
  RiSearchLine,
  RiShoppingBagLine,
} from 'react-icons/ri';

import { $cartList } from '@/features/cart/model';
import { $comparisonList } from '@/features/compare/model';
import { $favoriteList } from '@/features/favorites/model';
import { $inputValue, onInputChange, searchProduct } from '@/features/filters/model';

import { DomStankovLogo } from './DomStankovLogo';

export const Header = () => {
  const [open, setOpen] = useState(false);
  const [search, value, change, favorites, compare, cart] = useUnit([
    searchProduct,
    $inputValue,
    onInputChange,
    $favoriteList,
    $comparisonList,
    $cartList,
  ]);
  return (
    <header className="site-header">
      <a className="skip-link" href="#main">
        К содержимому
      </a>
      <div className="header-main container">
        <Link href="/" className="brand" aria-label="Дом Станков — главная">
          <DomStankovLogo />
        </Link>
        <Link href="/catalog" className="header-catalog">
          <RiGridFill />
          Каталог
        </Link>
        <form
          className="header-search"
          role="search"
          onSubmit={(event) => {
            event.preventDefault();
            if (value.trim()) {
              search({ search: value.trim() });
              setOpen(false);
            }
          }}
        >
          <input
            aria-label="Поиск оборудования"
            type="search"
            value={value}
            onChange={(event) => change(event.target.value)}
            placeholder="Найти станок или оборудование"
          />
          <button type="submit" aria-label="Найти">
            <RiSearchLine />
          </button>
        </form>
        <nav className="header-tools" aria-label="Личный выбор">
          {[
            { href: '/compare', label: 'Сравнение', icon: <RiBarChartHorizontalLine />, count: compare.length },
            { href: '/favorites', label: 'Избранное', icon: <RiHeartLine />, count: favorites.length },
            { href: '/cart', label: 'Корзина', icon: <RiShoppingBagLine />, count: cart.length },
          ].map((item) => (
            <Link key={item.href} href={item.href} aria-label={`${item.label}${item.count ? ` (${item.count})` : ''}`}>
              {item.icon}
              <span>{item.label}</span>
              {item.count > 0 && <b>{item.count}</b>}
            </Link>
          ))}
        </nav>
        <a className="header-phone" href="tel:+73433630507">
          <span>
            <RiPhoneLine />
            +7 (343) 363-05-07
          </span>
          <small>Пн–Пт: 10:00–19:00</small>
        </a>
        <button
          className="header-menu"
          aria-label={open ? 'Закрыть меню' : 'Открыть меню'}
          aria-expanded={open}
          aria-controls="site-navigation"
          type="button"
          onClick={() => setOpen(!open)}
        >
          {open ? <RiCloseLine /> : <RiMenuLine />}
        </button>
      </div>
      <div className={`header-nav${open ? ' is-open' : ''}`} id="site-navigation">
        <div className="container">
          <nav aria-label="Основная навигация">
            <Link href="/catalog" onClick={() => setOpen(false)}>
              Оборудование
            </Link>
            <Link href="/#about" onClick={() => setOpen(false)}>
              О компании
            </Link>
            <Link href="/delivery-and-payment" onClick={() => setOpen(false)}>
              Доставка и оплата
            </Link>
            <Link href="/#contacts" onClick={() => setOpen(false)}>
              Контакты
            </Link>
          </nav>
          <a href="mailto:zakaz@domstankov.com">
            zakaz@domstankov.com
            <RiArrowRightLine />
          </a>
        </div>
      </div>
    </header>
  );
};
